export const API_BASE = "https://civil3d-api-255115267503.us-east1.run.app";
export const WS_BASE  = "wss://civil3d-api-255115267503.us-east1.run.app";

export const STEP_NAMES = {
  0:  "Video Intelligence",
  1:  "Camera Positions",
  2:  "Metric Depth Maps",
  3:  "3D Scene Reconstruction",
  4:  "Surface Refinement",
  5:  "AI Surface Labeling",
  6:  "Spatial Measurements",
  7:  "2D Technical Drawings",
  8:  "Photorealistic Render",
  9:  "3D Browser Viewer",
  10: "AI Spatial Assistant",
};

export const STEP_ETA = {
  0:  "~15s",
  1:  "~1s",    2:  "~30s",   3:  "~37s",
  4:  "~24s",   5:  "~18s",   6:  "~1s",
  7:  "~2s",    8:  "~30min", 9:  "~1s",
  10: "~22s",
};

export async function apiHeaders(user) {
  const token = user ? await user.getIdToken() : 'stub';
  return {
    'Authorization': `Bearer ${token}`,
    'x-api-key': 'test-key-123',
  };
}
